import { FaTachometerAlt, FaShieldAlt, FaUsers } from 'react-icons/fa';

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Your Trusted Taxi Service for Safe and Reliable Rides",
    content: "At QuickRide, we are committed to providing top-notch taxi services that guarantee your safety, comfort, and satisfaction with every ride.",
    points: [
        {
            id: 1,
            icon: <FaTachometerAlt />, // Speedometer icon
            title: 'Fast Booking',
            content: 'Experience the ease of booking a taxi within seconds through our user-friendly platform.',
        },
        {
            id: 2,
            icon: <FaShieldAlt />, // Shield icon
            title: 'Safe Rides',
            content: 'Your safety is our priority. We ensure all our vehicles are regularly maintained.',
        },
        {
            id: 3,
            icon: <FaUsers />, // Users icon
            title: 'Professional Drivers',
            content: 'Our experienced drivers are not only professionals on the road but also friendly and courteous.',
        },
    ]
}

export default whyChooseUs;